module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-blue m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12"
  }, [_c('h6', {
    staticClass: "mb-0 font-weight-thin"
  }, [_vm._v("Exibir/Ocultar Colunas:")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.vehicle === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('vehicle'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Veículo ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.vehicle === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.year === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('year'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Mod/Fab ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.year === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.brand === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('brand'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Marca ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.brand === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.plate === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('plate'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Placa ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.plate === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.color === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('color'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("cor ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.color === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.tenant === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('tenant'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Loja ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.tenant === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.price === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('price'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Preço ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.price === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.days === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('days'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Dias em estoque ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.days === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.lastAction === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('lastAction'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Ultima ação ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.lastAction === true ? 'visibility' : 'visibility_off'))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "min-height": "350px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "pb-0 mb-0"
  }, [(_vm.show.vehicle) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleFilter),
      expression: "vehicleFilter"
    }],
    staticStyle: {
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.vehicleFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.year) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.yearForSearch,
      "reduce": function (ano) { return ano; },
      "label": "ano"
    },
    model: {
      value: (_vm.yearFilter),
      callback: function($$v) {
        _vm.yearFilter = $$v
      },
      expression: "yearFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.brandForSearch,
      "reduce": function (marca) { return marca; },
      "label": "marca"
    },
    model: {
      value: (_vm.brandFilter),
      callback: function($$v) {
        _vm.brandFilter = $$v
      },
      expression: "brandFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.plate) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.plateForSearch,
      "reduce": function (placa) { return placa; },
      "label": "placa"
    },
    model: {
      value: (_vm.plateFilter),
      callback: function($$v) {
        _vm.plateFilter = $$v
      },
      expression: "plateFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.color) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.colorForSearch,
      "reduce": function (cor) { return cor; },
      "label": "cor"
    },
    model: {
      value: (_vm.colorFilter),
      callback: function($$v) {
        _vm.colorFilter = $$v
      },
      expression: "colorFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.tenant) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.tenantForSearch,
      "reduce": function (loja) { return loja; },
      "label": "loja"
    },
    model: {
      value: (_vm.tenantFilter),
      callback: function($$v) {
        _vm.tenantFilter = $$v
      },
      expression: "tenantFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.price) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceFilter),
      expression: "priceFilter"
    }],
    staticStyle: {
      "width": "70px",
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.priceFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.priceFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.days) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.daysFilter),
      expression: "daysFilter"
    }],
    staticStyle: {
      "width": "50px",
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.daysFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.daysFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.lastAction) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastActionFilter),
      expression: "lastActionFilter"
    }],
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.lastActionFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastActionFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionsFilter),
      expression: "actionsFilter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.actionsFilter) ? _vm._i(_vm.actionsFilter, null) > -1 : (_vm.actionsFilter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.actionsFilter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.actionsFilter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.actionsFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.actionsFilter = $$c
        }
      }
    }
  }), _vm._v(" Reservados\n                ")])])]), _vm._v(" "), _c('thead', [_c('tr', [(_vm.show.vehicle) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Veículo")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.vehicleSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.year) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Mod/Fab")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.yearSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Brand")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.brandSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.plate) ? _c('th', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.show.color) ? _c('th', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.show.tenant) ? _c('th', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.show.price) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Preço")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.priceSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.days) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Dias em estoque")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.ordenaDisable
    },
    on: {
      "click": _vm.daysSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.show.lastAction) ? _c('th', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "min-height": "700px",
      "max-width": "100%"
    }
  }, [(_vm.entriesOthersEntities.length) ? _vm._l((_vm.filteredEntries), function(entry, i) {
    return _c('tr', {
      key: i + 'table',
      staticStyle: {
        "min-height": "700px",
        "max-width": "100%"
      }
    }, [(_vm.show.vehicle) ? _c('td', [_vm._v(_vm._s(entry.full_name) + " ")]) : _vm._e(), _vm._v(" "), (_vm.show.year) ? _c('td', [_vm._v(_vm._s(entry.fabrication_year))]) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('td', [_vm._v(_vm._s(entry.brand))]) : _vm._e(), _vm._v(" "), (_vm.show.plate) ? _c('td', [_vm._v(_vm._s(entry.plate))]) : _vm._e(), _vm._v(" "), (_vm.show.color) ? _c('td', [_vm._v(_vm._s(entry.color))]) : _vm._e(), _vm._v(" "), (_vm.show.tenant) ? _c('td', [_vm._v(_vm._s(entry.tenant_fancy_name))]) : _vm._e(), _vm._v(" "), (_vm.show.price) ? _c('td', [_vm._v("R$ " + _vm._s(entry.sale_price))]) : _vm._e(), _vm._v(" "), (_vm.show.days) ? _c('td', {
      class: {
        overdue: _vm.totalOfDays(entry.created_at) >= 60
      }
    }, [_vm._v(_vm._s(_vm.totalOfDays(entry.created_at)))]) : _vm._e(), _vm._v(" "), (_vm.show.lastAction) ? _c('td', [_vm._v(_vm._s(entry.description))]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.profile.map['vehicle-entries'].includes('info')) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'VehicleEntryEdit',
            params: {
              id: entry.id
            }
          })
        }
      }
    }, [_vm._v("Detalhes")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.abreReserva(entry)
        }
      }
    }, [(entry.state_id === 3) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("Reservado")]) : _c('span', {
      staticClass: "green--text"
    }, [_vm._v("Reservar")])])])])
  }) : [_vm._m(6)]], 2)])])])])]), _vm._v(" "), _c('Reserva')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-archive fa-lg"
  }), _vm._v("\n          Veículos disponíveis\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Placa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Cor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Loja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Última Ação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v("Não há veículos cadastrados")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5949b7f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NovoEstoque.vue
// module id = 1019
// module chunks = 1